import { IFont, MediaType } from '@meitu/saas-editor-core/es/version-types';
import { DEFAULT_FONT_FAMILY } from '@meitu/saas-editor-core/es/version-types/font';

export function findFont(fonts: IFont[], fontName: string) {
    return fonts.find((fonts) => fonts.font_name === fontName || fonts.default_name === fontName);
}

export const findFontLostAndReplace = function (
    textData: { fontFamily: string; textContents?: { fontFamily: string }[] },
    fontList: IFont[],
    /** 除了找不到的字体, 业务方去决定哪些字体也是丢失的 */
    isFontLost?: (fontName: string) => boolean,
    /** 不做替换逻辑 */
    noReplace = false,
) {
    const lostFonts: string[] = [];
    const { fontFamily, textContents } = textData;

    if (!findFont(fontList, fontFamily) || isFontLost?.(fontFamily)) {
        lostFonts.push(textData.fontFamily);
        if (!noReplace) {
            textData.fontFamily = DEFAULT_FONT_FAMILY().name;
        }
    }

    textContents?.forEach((item, i) => {
        if (item.fontFamily && (!findFont(fontList, item.fontFamily) || isFontLost?.(item.fontFamily))) {
            lostFonts.push(textContents[i].fontFamily);
            if (!noReplace) {
                textContents[i].fontFamily = DEFAULT_FONT_FAMILY().name;
            }
        }
    });
    return lostFonts;
};

export const getMediaType = (url: string) => {
    try {
        const parsedUrl = new URL(url);
        const pathname = parsedUrl.pathname.toLowerCase();
        const lastDotIndex = pathname.lastIndexOf('.');
        const type = lastDotIndex !== -1 ? pathname.substring(lastDotIndex + 1) : null;
        // todo 判断是否多帧，多帧渲染为media
        if (type === 'gif') {
            return {
                isMediaLayer: true,
                mediaType: MediaType.Image,
            };
        }

        if (type === 'webm') {
            return {
                isMediaLayer: true,
                mediaType: MediaType.Video,
            };
        }

        return {
            isMediaLayer: false,
            mediaType: MediaType.Image,
        };
    } catch (e) {
        console.error('Invalid URL:', e);
        return {
            isMediaLayer: false,
            mediaType: MediaType.Image,
        };
    }
};
